import { render, staticRenderFns } from "./ErrorCantCreate.vue?vue&type=template&id=4992252c&scoped=true&"
import script from "./ErrorCantCreate.vue?vue&type=script&lang=js&"
export * from "./ErrorCantCreate.vue?vue&type=script&lang=js&"
import style0 from "./ErrorCantCreate.vue?vue&type=style&index=0&id=4992252c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4992252c",
  null
  
)

export default component.exports